module.exports = __webpack_public_path__ + "static/img/next.513c6020.png";